import { render, staticRenderFns } from "./OtherOfficeMessageListTab.vue?vue&type=template&id=7ac037ef&scoped=true&lang=pug"
import script from "./OtherOfficeMessageListTab.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeMessageListTab.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeMessageListTab.vue?vue&type=style&index=0&id=7ac037ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac037ef",
  null
  
)

export default component.exports